
import { Component, Prop, Watch } from 'vue-property-decorator'
import AppInput from '@/components/AppInput.vue'
import { partnerEntity } from '@/models/models'
import { ChildComponentMixin } from '@/mixins'
import { cloneDeep } from 'lodash'

@Component({
    components: {
        AppInput,
    },
})

export default class PartnerFormAccessData extends ChildComponentMixin {
    @Prop() public value?: PartnerEntity
    private clipboardSelectedId = ''

    get partner(): PartnerEntity {
        return this.value ?? partnerEntity
    }

    get apikeyStatusOptions(): InputSelectOptionEntity[] {
        return [
            { value: 'ACTIVE', text: 'Ativo' },
            { value: 'INACTIVE', text: 'Inativo' },
        ]
    }

    get storeStatusOptions(): InputSelectOptionEntity[] {
        return [
            { value: 'SANDBOX', text: 'Sandbox' },
            { value: 'DELETED', text: 'Deletado' },
        ]
    }

    get statusOptions(): InputSelectOptionEntity[] {
        return [
            { value: 'INITIATED', text: 'Iniciada' },
            { value: 'FINISHED', text: 'Finalizada' },
        ]
    }

    public inputIcon(selectedId: string) {
        return this.clipboardSelectedId === selectedId ? ['fas', 'check-circle'] : ['far', 'copy']
    }

    public inputHint(selectedId: string) {
        return this.clipboardSelectedId === selectedId ? 'Copiado' : 'Clique no ícone para copiar'
    }

    public copyToClipboard(selectedId: string) {
        this.clipboardSelectedId = selectedId;

        (document.querySelector(`#${selectedId} input`) as any).select()
        document.execCommand('copy')
    }

    public openLink(link: string) {
        window.open(link, '_blank')
    }
}
